import { TimerTrayItem } from "components/floating-timer/timer-tray-item";
import { SupportTrayItem } from "components/layout/support-tray-item";
import React from "react";

export const UtilityStrip: React.FC = () => {
    return (
        <div className="ml-auto flex items-center gap-2 py-2.5">
            <TimerTrayItem />
            <SupportTrayItem />
        </div>
    );
};
